import { __exports as s } from "./index860.mjs";
import { d as f } from "./index795.mjs";
import { v as n } from "./index827.mjs";
import "./index762.mjs";
import { a as m } from "./index828.mjs";
import { t as v } from "./index809.mjs";
import { o as d } from "./index757.mjs";
import { __exports as c } from "./index765.mjs";
var b = f, j = n, P = c, y = m, _ = v, x = d;
s.f = b && !j ? Object.defineProperties : function(e, r) {
  y(e);
  for (var i = _(r), o = x(r), p = o.length, t = 0, a; p > t; )
    P.f(e, a = o[t++], i[a]);
  return e;
};
export {
  s as default
};
